import type { Quiz } from '../services/api';

/**
 * Quiz ainda bloqueado por missão de carreira (cadeado / não iniciar).
 * Quando `careerUnlockedForUser` não vem na resposta (ex.: client antigo), trata como bloqueado se `isUnlockable`.
 */
export function isQuizCareerLocked(quiz: Quiz): boolean {
  if (!quiz.isUnlockable) return false;
  return quiz.careerUnlockedForUser !== true;
}
